/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerInvitations} from '../api'

export const useMutationRegisterInvitations = createReactQueryMutationHook('registerInvitations', registerInvitations)
